import { Controller } from "@hotwired/stimulus"

// File/image upload widget (replaces the former Alpine x-data/x-ref component
// emitted by app/core/fields.py and app/sites/fields.py). This is a thin
// adapter: it builds the `data`/`refs` objects the upload handlers in
// dash/main.js expect (formerly Alpine's $data/$refs) from Stimulus
// values/targets, then delegates to the existing upload logic.
//
// NB: don't add a getter/property named `data` or `refs` here — `this.data` is
// reserved by Stimulus for its value data-map; shadowing it recurses infinitely.
export default class extends Controller {
  static targets = ["urlInput", "hidden", "progress", "progressBar"]
  static values = { fieldId: String, uploadUrl: String, ctype: String }

  pick(event) {
    if (event) event.preventDefault()
    if (!window.main || typeof window.main.onUploadClick !== "function") return
    const data = {
      field_id: this.fieldIdValue,
      upload_url: this.uploadUrlValue,
      ctype: this.ctypeValue,
    }
    const refs = {
      url_input: this.urlInputTarget,
      hidden: this.hiddenTarget,
      progress: this.progressTarget,
      progressBar: this.progressBarTarget,
    }
    window.main.onUploadClick(data, refs)
  }
}
